import config from "./seoConfig.json";
import type { SeoConfig } from "./builders";

/**
 * Single source of truth for site-wide SEO values. The same JSON is read by
 * scripts/prerender.js at build time, so the static HTML served to crawlers
 * and the tags React Helmet writes at runtime can never drift apart.
 */
export const seoConfig: SeoConfig = config;
export const SITE_URL: string = config.siteUrl;
export const SITE_NAME: string = config.siteName;
export const DEFAULT_IMAGE = config.defaultImage;
export const LOGO_PATH: string = config.logoPath;
export const LOCALE: string = config.locale;

export type PageMetaKey = keyof typeof config.pages;
export const pageMeta = config.pages;

/** Turn a site-relative path (or an already absolute URL) into an absolute URL. */
export const absoluteUrl = (pathOrUrl: string): string => {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  return `${SITE_URL}${pathOrUrl.startsWith("/") ? "" : "/"}${pathOrUrl}`;
};

/** Canonical form of a path: no trailing slash (except "/"), no query, no hash. */
export const canonicalPath = (path: string): string => {
  const clean = (path.split(/[?#]/)[0] ?? "/").replace(/\/+$/, "");
  return clean === "" ? "/" : clean;
};
